import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { config } from '@tools/ui/consts';
// eslint-disable-next-line import/no-extraneous-dependencies
import { translation } from '@tools/ui-locales';

export const resources = {
  en: {
    translation,
  },
};

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en-US',
  debug: config.appEnv !== 'production',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});
